export default __webpack_public_path__ + "static/dt-tablet-5e39c5fe6b40443a83bb3f6488dc03f0.png";